export default "/images/6bb29d83a573b09aecfeb2648d52eb98.avif";